import { yupResolver } from "@hookform/resolvers/yup";
import FormInput from "components/Common/Form/Input/FormInput";
import { Button, Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useModal } from "src/hooks/useModal";
import {
  ForgotPasswordFormData,
  forgotPasswordSchema,
} from "./PasswordInit.schema";
import { usePasswordInit } from "src/hooks/api/auth/usePasswordInit";
import styles from "./index.module.scss";
import { FormContainer } from "components/Common/Form/Input/FormContainer";
import { SubmitBtn } from "components/Common/Form/SubmitBtn";
import { useTranslation } from "react-i18next";

const PasswordInitModal = () => {
  const { isOpenPasswordInitModal, setPasswordInitModal } = useModal();
  // 로그인 폼 관리
  const passwordInitForm = useForm<ForgotPasswordFormData>({
    resolver: yupResolver(forgotPasswordSchema),
    defaultValues: {
      forgetUserId: "",
      forgetUserName: "",
    },
    mode: "onBlur",
  });
  const { register, handleSubmit, formState } = passwordInitForm;
  const { isLoading: isInitLoading, mutatePasswordInit } = usePasswordInit({
    setStateInit: () => {
      passwordInitForm.reset();
    },
  });
  // 비밀번호 찾기 폼 제출 핸들러
  const onForgotPasswordSubmit = (data: ForgotPasswordFormData) => {
    if (!isInitLoading) {
      // console.log("data", data);
      mutatePasswordInit({
        userId: data.forgetUserId,
        userName: data.forgetUserName,
      });
      setPasswordInitModal(false);
    }
  };
  const { t } = useTranslation();
  return (
    <>
      {isOpenPasswordInitModal && (
        <Modal
          show={isOpenPasswordInitModal}
          onHide={() => setPasswordInitModal(false)}
          centered
          style={{ opacity: 1 }}
          // dialogClassName="custom-modal-width" // CSS에서 .custom-modal-width { max-width: 554px; } 정의
        >
          <Modal.Header closeButton>
            <label className={styles.inputLabel}>
              {t("logIn.resetPassowrd.resetPasswordBtn")}
            </label>
          </Modal.Header>

          <Modal.Body style={{ width: "554px" }}>
            <FormProvider {...passwordInitForm}>
              <FormContainer onSubmit={handleSubmit(onForgotPasswordSubmit)}>
                <FormInput
                  label={t("navBar.myAccount.email")}
                  name="forgetUserId"
                  type="email"
                  register={register}
                  errors={formState.errors}
                  placeholder={t("logIn.enterUserEmail")}
                />
                <FormInput
                  label={t("logIn.signUp.name")}
                  name="forgetUserName"
                  type="text"
                  register={register}
                  errors={formState.errors}
                  placeholder={t("logIn.enterName")}
                />

                {/* 버튼들 추가 */}
                <div style={{ marginTop: "24px" }}>
                  <SubmitBtn
                    text={t("logIn.resetPassowrd.resetPasswordBtn")}
                    disabled={!formState.isValid}
                    className={styles.passwordInitButton}
                  />
                </div>

                <a
                  onClick={() => setPasswordInitModal(false)}
                  className={styles.goBackToLogin}
                >
                  {t("logIn.resetPassowrd.goBackToLogin")}
                </a>
              </FormContainer>
            </FormProvider>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default PasswordInitModal;
